import { setGA4Event } from "@iewc/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getBillTo } from "@insite/client-framework/Services/CustomersService";
import {
    chain,
    DispatchCompleteSignIn,
    NavigateToReturnUrl,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

addToChainAfter(chain, DispatchCompleteSignIn, async props => {
    if (props.authenticatedSession) {
        const billTo = props.authenticatedSession?.isAuthenticated
            ? await getBillTo({
                  billToId: API_URL_CURRENT_FRAGMENT,
              })
            : null;

        const sapAccountNumber =
            props.authenticatedSession.isAuthenticated && billTo
                ? billTo.customerNumber.replace(/^0+/, "")
                : "__IS_LOADING__";

        const userID = props.authenticatedSession.userProfileId;

        setGA4Event([], "sign_in", { userID, sapAccountNumber });
    }
});

replaceInChain(chain, NavigateToReturnUrl, async props => {
    if (!props.authenticatedSession) {
        return;
    }

    const state = props.getState();
    let returnUrl = props.parameter.returnUrl;
    const dashboardPageUrl = getPageLinkByPageType(props.getState(), "MyAccountPage")?.url;

    const defaultUrl = props.authenticatedSession.isGuest
        ? ""
        : props.authenticatedSession.dashboardIsHomepage && dashboardPageUrl
        ? dashboardPageUrl
        : props.authenticatedSession.customLandingPage
        ? props.authenticatedSession.customLandingPage
        : "";

    const orderApprovalDetailsPageUrl = getPageLinkByPageType(props.getState(), "OrderApprovalDetailsPage")?.url;
    const bypassDefaultUrlIfOrderDetails =
        props.parameter.returnUrl &&
        orderApprovalDetailsPageUrl &&
        props.parameter.returnUrl.toLowerCase().indexOf(orderApprovalDetailsPageUrl.toLowerCase()) > -1 &&
        (props.parameter.returnUrl.toLowerCase().indexOf("external-approval=") > -1 ||
            props.parameter.returnUrl.toLowerCase().indexOf("external-approval-view=") > -1);

    // Verndale Customization
    const rfqGuestPageUrl = getPageLinkByPageType(state, "RfqRequestQuoteGuestAddressPage")?.url;
    const isRFQGuest = returnUrl?.toLowerCase() === rfqGuestPageUrl?.toLowerCase();
    // END Verndale Customization

    if (defaultUrl !== "" && !bypassDefaultUrlIfOrderDetails && !isRFQGuest) {
        window.location.href = defaultUrl;
        return;
    }

    const checkoutShippingUrl = getPageLinkByPageType(state, "CheckoutShippingPage")?.url;
    const isCheckoutGuest = returnUrl?.toLowerCase() === rfqGuestPageUrl?.toLowerCase();

    if (returnUrl?.toLowerCase() === checkoutShippingUrl?.toLowerCase() || isRFQGuest) {
        const cartResult = await getCart({
            cartId: API_URL_CURRENT_FRAGMENT,
            expand: ["cartLines", "hiddenproducts"],
        } as GetCartApiParameter);

        const { canCheckOut, canBypassCheckoutAddress } = cartResult.cart;
        const checkoutReviewAndSubmitUrl = getPageLinkByPageType(state, "CheckoutReviewAndSubmitPage")?.url;
        const cartUrl = getPageLinkByPageType(state, "CartPage")?.url;

        // Verndale Customization
        if (
            (!canCheckOut || props.authenticatedSession.isRestrictedProductExistInCart) &&
            !isRFQGuest &&
            !isCheckoutGuest
        ) {
            returnUrl = cartUrl;
        } else if (isRFQGuest) {
            returnUrl = `${rfqGuestPageUrl}?cartId=${cartResult.cart.id}`;
        } else if (props.authenticatedSession.isGuest && isCheckoutGuest) {
            returnUrl = checkoutShippingUrl;
        } else if (canBypassCheckoutAddress) {
            returnUrl = checkoutReviewAndSubmitUrl;
        }
        // END Verndale Customization
    }

    if (returnUrl?.includes("SwitchingLanguage")) {
        returnUrl = returnUrl.split("?")[0];
    }

    const homePageUrl = getHomePageUrl(state);
    if (returnUrl?.toLowerCase() === homePageUrl.toLowerCase() && props.authenticatedSession?.customLandingPage) {
        // need to send to custom landing page if the return URL is a language specific homepage
        if (returnUrl?.endsWith("/")) {
            returnUrl = returnUrl.substring(0, returnUrl.length - 1);
        }
        if (props.authenticatedSession?.customLandingPage.startsWith("/")) {
            returnUrl = `${returnUrl}${props.authenticatedSession?.customLandingPage}`;
        } else {
            returnUrl = `${returnUrl}/${props.authenticatedSession?.customLandingPage}`;
        }
    } else if (
        returnUrl?.toLowerCase() === homePageUrl.toLowerCase() &&
        props.authenticatedSession.dashboardIsHomepage &&
        dashboardPageUrl
    ) {
        // case where returnUrl is a language-specific homepage but we should redirect to the dashboard
        returnUrl = defaultUrl;
    }

    window.location.href = returnUrl || homePageUrl;
});
